package com.wintermar.inspection.feature.presentation.inspection.complete

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

class InspectionCompleteState(
    private val onApproveInspection: () -> Unit,
    private val onDownloadInspectionReport: () -> Unit,
    private val onEditInspection: () -> Unit
) {
    var isLoading by mutableStateOf(false)

    fun onApprove() {
        onApproveInspection()
    }

    fun onDownloadReport() {
        onDownloadInspectionReport()
    }

    fun onEdit() {
        onEditInspection()
    }
}
